import { formatUnits } from "ethers";

class TokenDetails {
    get supplyFormatted() {
        return this.#formatTokenAmount(this.supply, this.precision, this.symbol);
    }

    get maxSupplyFormatted() {
        if (!this.maxSupply) {
            return undefined;
        }

        return this.#formatTokenAmount(this.maxSupply, this.precision, this.symbol);
    }

    constructor({name, maxSupply, currentSupply = 0n, precision, symbol, contractAddress}) {
        this.name = name;
        this.maxSupply = maxSupply; // Might be undefined
        this.supply = currentSupply;
        this.precision = precision;
        this.symbol = symbol;
        this.contractAddress = contractAddress;
    }

    increaseSupply(units) {
        this.supply += units;
    };

    #formatTokenAmount(amount, precision, symbol) {
        return `${formatUnits(amount, precision)} ${symbol}`;
    };
}

export default TokenDetails;
